import React from 'react';
import PropTypes from 'prop-types';
import { Card, Button } from 'react-bootstrap';

const EntryBlock = ({ title, content, onRemove }) => {
    return (
    <Card style={styles.card} className="mb-2">
      <Card.Body className="d-flex justify-content-between align-items-center">
        <div>
          <Card.Title className="mb-1" style={styles.title}>
            {title}
          </Card.Title>
          <Card.Text>{content}</Card.Text>
        </div>
        <Button
          variant="link"
          onClick={onRemove}
          style={styles.removeButton}
          className="text-danger"
        >
          &#10005; {/* Unicode for a simple "x" close icon */}
        </Button>
      </Card.Body>
    </Card>
  );
};

const styles = {
  card: {
    borderRadius: '10px',
    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)', // Adds a subtle shadow
  },
  title: {
    fontWeight: 'bold',
  },
  removeButton: {
    border: 'none',
    padding: '0',
    marginLeft: '10px',
  },
};


EntryBlock.propTypes = {
  title: PropTypes.string.isRequired,
  content: PropTypes.string.isRequired,
  onRemove: PropTypes.func.isRequired,
};

export default EntryBlock;
